module.exports = __webpack_public_path__ + "img/poster-transport.7c9f5449.jpg";